import { useLocation, useNavigate } from "react-router-dom";
import { Sun, Mic, History, MoreHorizontal, Upload } from "lucide-react";
import { useAuth } from "../App";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "./ui/dropdown-menu";

const MobileNav = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { user } = useAuth();
  
  const isAdmin = user?.role === "admin" || user?.role === "super_admin";
  const isStaff = user?.role === "staff";
  
  // Staff users have limited navigation
  const mainItems = isStaff ? [
    { path: "/app/my-day", label: "My Day", icon: Sun },
    { path: "/app/scribe", label: "Scribe", icon: Mic },
    { path: "/app/history", label: "History", icon: History },
  ] : [
    { path: "/app/my-day", label: "My Day", icon: Sun },
    { path: "/app/upload", label: "Audit", icon: Upload },
    { path: "/app/scribe", label: "Scribe", icon: Mic },
    { path: "/app/history", label: "History", icon: History },
  ];
  
  const moreItems = isStaff ? [
    { path: "/app/voice-note", label: "Voice Note + Coach" },
    { path: "/app/idg-meeting-prep", label: "IDG Meeting Prep" },
    { path: "/app/settings", label: "Settings" },
  ] : [
    { path: "/app/eligibility", label: "Eligibility" },
    { path: "/app/batch", label: "Batch Process" },
    { path: "/app/compliance", label: "Compliance Q&A" },
    { path: "/app/compliance-dashboard", label: "Security" },
    { path: "/app/insights", label: "AI Insights" },
    { path: "/app/settings", label: "Settings" },
    ...(isAdmin ? [
      { path: "/app/users", label: "Users" },
      { path: "/app/audit-logs", label: "Audit Logs" },
    ] : []),
    ...(user?.role === "super_admin" ? [
      { path: "/app/super-admin", label: "Super Admin" },
    ] : []),
  ];
  
  const isActive = (path) => location.pathname === path;
  
  return (
    <nav className="mobile-nav lg:hidden" data-testid="mobile-nav">
      <div className="flex items-center justify-around">
        {mainItems.map((item) => {
          const Icon = item.icon;
          return (
            <button
              key={item.path}
              onClick={() => navigate(item.path)}
              className={`mobile-nav-item touch-feedback ${isActive(item.path) ? "active" : ""}`}
              data-testid={`mobile-nav-${item.label.toLowerCase()}`}
            >
              <Icon />
              <span>{item.label}</span>
            </button>
          );
        })}
        
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <button className="mobile-nav-item touch-feedback" data-testid="mobile-nav-more">
              <MoreHorizontal />
              <span>More</span>
            </button>
          </DropdownMenuTrigger>
          <DropdownMenuContent align="end" className="w-48 mb-2">
            {moreItems.map((item) => (
              <DropdownMenuItem
                key={item.path}
                onClick={() => navigate(item.path)}
                className="cursor-pointer"
              >
                {item.label}
              </DropdownMenuItem>
            ))}
          </DropdownMenuContent>
        </DropdownMenu>
      </div>
    </nav>
  );
};

export default MobileNav;
